import React from "react";

export default function KidsBrand() {
  return (
    <span className="kids-brand" aria-label="Atlas Kids" dir="ltr" lang="en" translate="no">
      <svg
        viewBox="0 0 38 38"
        width="34"
        height="34"
        aria-hidden="true"
        focusable="false"
      >
        <circle
          cx="19"
          cy="19"
          r="16"
          fill="var(--kids-brand-icon-bg, #c52b71)"
        />
        <path d="m15 11 12 8-12 8Z" fill="var(--kids-brand-icon-ink, #fff)" />
        <circle cx="32" cy="7" r="4" fill="#ffd84b" />
      </svg>
      <span className="kids-brand-name" aria-hidden="true">
        ATLAS
        <b>
          <i>k</i>
          <i>i</i>
          <i>d</i>
          <i>s</i>
        </b>
      </span>
    </span>
  );
}
